import { ScrollableArea } from '@approvalmax/ui';
import styled from 'styled-components';

export const Root = styled.div`
    display: flex;
    flex-direction: column;
`;

export const ScrollableAreaStyled = styled(ScrollableArea)`
    flex: 1;
    border-top: 1px solid #e4e4e4;

    @media only screen and (max-height: 600px) {
        overflow: unset;
    }
`;
